import React from 'react';
import ContactForm from './ContactForm';

const View = () => <ContactForm />;

export default View;